import { mathDelimitersFromMarkdown } from "./mdast-util-math-delimiters";
import { mathDelimitersTokenizer } from "./micromark-extension-math-delimiters";
import { render } from "./render";
export const markdownViewerExtension = {
    tokenizer: mathDelimitersTokenizer(),
    tokensToMdast: mathDelimitersFromMarkdown(),
    mdastRender: render
};
